<template>
  <a-modal v-model="visible" title="上传本校创新拔尖人次名单" :footer="null" width="700px" @cancel="closeModal(true)">
    <div class="modal-container">
      <a-form-model ref="formRef" :rules="rules" :model="form" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-form-model-item label="创新拔尖人才描述" prop="description">
          <a-input :maxLength="35" v-model="form.description" placeholder="不超过35个字符" />
        </a-form-model-item>
        <a-form-model-item label="本校拔尖人才选择" prop="innovativeTalentStandard">
          <a-select v-model="form.innovativeTalentStandard" placeholder="请选择创新人才标准">
            <a-select-option :value="1"> 依据大脑学习力测评 </a-select-option>
            <a-select-option :value="2"> 依据学校学业成绩</a-select-option>
            <a-select-option :value="3"> 依据学校分班（快慢班） </a-select-option>
          </a-select>
        </a-form-model-item>
        <div>
          <a-spin :spinning="uploadLoading">
            <a-divider orientation="left">数据模板下载</a-divider>
            <p style="text-align: center">
              <a download="创新拔尖人才导入模板" :href="DownloadTemplate">点击下载模板</a>
            </p>
            <a-divider orientation="left">批量导入学生</a-divider>
            <a-upload-dragger name="file" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
              <p class="ant-upload-drag-icon">
                <a-icon type="cloud-upload" />
              </p>
              <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
              <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
            </a-upload-dragger>
            <div class="error-data" v-if="errorData.data" @click="downLoadStudentError">下载错误数据</div>
            <p style="text-align: center; margin: 20px 0">
              <a-button :loading="confirmLoading" @click="submit" type="primary">导入数据</a-button>
            </p>
          </a-spin>
        </div>
      </a-form-model>
      <div class="modal-tip">温馨提示：学生姓名，性别，出生日期如有一项不同系统即可识别不同学生，但为了方便教师使用建议提前修改姓名区分，如刘伟（大），刘伟（小）</div>
    </div>
  </a-modal>
</template>
<script>
import { arrayToXlsx } from '@/utils/util'
export default {
  name: 'UploadStudent',
  data() {
    return {
      DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/%E5%AF%BC%E5%85%A5%E5%88%9B%E6%96%B0%E4%BA%BA%E6%89%8D%E6%A8%A1%E7%89%88.xlsx',
      form: {
        description: undefined,
        innovativeTalentStandard: undefined,
      },
      rules: {
        description: [{ required: true, message: '请输入创新拔尖人才描述' }],
        innovativeTalentStandard: [{ required: true, message: '请选择创新人才标准', trigger: 'change' }],
      },
      uploadLoading: false,
      fileList: [],
      confirmLoading: false,
      visible: false,
      errorData: {
        data: null,
      },
    }
  },
  methods: {
    downLoadStudentError() {
      if (!this.errorData.data) return
      const columns = ['姓名', '性别', '出生日期', '学校名称', '错误信息']
      const exportKeys = ['realName', 'genderName', 'birthday', 'organizationName', 'errorMessage']
      const exportData = []
      for (let i = 0; i < this.errorData.data.length; i++) {
        const item = this.errorData.data[i]
        const reulst = []
        exportKeys.forEach((key) => {
          const val = Array.isArray(item[key]) ? item[key].join('，') : item[key]
          reulst.push(val)
        })
        exportData.push(reulst)
      }
      arrayToXlsx(exportData, {
        columns,
        fileName: '错误数据.xlsx',
        generate: (obj) => {
          obj.aoa['!cols'] = Array.from({ length: columns.length }, (_, i) => (i + 1 === columns.length ? { wpx: 140 } : { wpx: 100 }))
          obj.setColumnFontColor({
            cell: 'E',
            len: this.errorData.data.length + 1,
            color: 'FF0000',
          })
        },
      })
    },
    async submit() {
      await this.$refs['formRef'].validate()
      if (!this.fileList[0]) {
        return this.$message.error('请上传文件')
      }
      this.confirmLoading = true
      const fm = new FormData()
      fm.append('description', this.form.description)
      fm.append('innovativeTalentStandard', this.form.innovativeTalentStandard)
      fm.append('excelfile', this.fileList[0])
      fm.append('groupReportId', this._options.groupReportId)
      const { data, isSuccess } = await this.$http.ReportService.importStudent(fm)
        .finally(() => (this.confirmLoading = false))
        .catch((err) => err)
      if (isSuccess) {
        this.$message.success('上传成功')
        this.closeModal(false, { standard: this.form.innovativeTalentStandard, description: this.form.description })
        this.errorData.grade = null
        return
      }
      if (data?.length) {
        this.errorData.data = data
      }
    },
    showModal(options) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.visible = true
        this._options = options
        if (options.record) {
          this.form.description = options.record.description
          this.form.innovativeTalentStandard = options.record.standard
        }
      })
    },
    closeModal(reject, params) {
      reject ? this._reject(params) : this._resolve(params)
      this.visible = false
      this.form = {
        description: '',
        innovativeTalentStandard: undefined,
      }
      this.errorData.data = null
      this.fileList = []
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload(file) {
      console.log(file.name.substr(-4, 4))
      if (!['xlsx', 'xls'].includes(file.name.substr(-4, 4))) {
        this.$message.error('请选择以“.xlsx，.xls”结尾的文件')
        return false
      }
      this.fileList = [file]
      this.errorData.grade = null
      return false
    },
  },
}
</script>

<style lang="less" scoped>
.error-data {
  color: red;
  cursor: pointer;
  margin-top: 10px;
}
</style>
